import campaignFetchers from '@/api/fetchers/campaign';
import useDataQuery from '@/hooks/use-data-query';

function useCampaignBrandActionItemsQuery({
  campaignId,
  enabled = true,
}: {
  campaignId: string;
  enabled: boolean;
}) {
  return useDataQuery({
    queryKey: ['campaignBrandActionItems', campaignId],
    queryFn: campaignFetchers.brandActionItems,
    enabled: !!campaignId && enabled,
    meta: {
      id: campaignId,
    },
  });
}

export default useCampaignBrandActionItemsQuery;
